import { TAG_STATUS } from '@evinced-private/ui-common';

import { AccessibilityStatus, TrendDirection } from './types';

export const STATUS_MAPPING = {
	[AccessibilityStatus.POOR]: { status: TAG_STATUS.FAILURE, text: 'Poor' },
	[AccessibilityStatus.MODERATE]: { status: TAG_STATUS.WARNING, text: 'Moderate' },
	[AccessibilityStatus.GOOD]: { status: TAG_STATUS.SUCCESS, text: 'Good' },
	[AccessibilityStatus.EXCELLENT]: { status: TAG_STATUS.SUCCESS, text: 'Excellent' }
} as const;

export const TREND_MAPPING = {
	[TrendDirection.UP]: TAG_STATUS.FAILURE,
	[TrendDirection.DOWN]: TAG_STATUS.SUCCESS
} as const;

export const INFO_CONTENT = {
	ACCESSIBILITY_SCORE:
		'Accessibility score reflects the number and severity of issues across all scanned URLs. It also factors in page complexity.',
	UNIQUE_ISSUES: 'Unique issues are single issue types found on one page.',
	UNIQUE_CRITICAL_ISSUES:
		'Unique critical issues are single issue types found on one page and marked as critical.',
	TOTAL_ISSUES: 'Total issues are all issues found across every session and test.',
	TOTAL_CRITICAL_ISSUES:
		'Total critical issues are all critical issues found across every session and test.'
} as const;
